<template>
    <div class="my-item3 z-info">
        <template v-if="list && list.items.length">
            <div style="min-height:210px;margin-bottom:20px;">
                <Row :gutter="30">
                    <Col
                            :sm="12"
                            :md="6"
                            class="w-20"
                    >
<!--                        <div class="addPro" @click="$router.push('/exhibition/index/product/addpro?num=' + totalCount)">-->
<!--                            <div></div>-->
<!--                            <i class="icon iconfont icon-jia3"></i>-->
<!--                            <span>添加产品</span>-->
<!--                        </div>-->
                    </Col>
                    <Col
                            :sm="12"
                            :md="6"
                            v-for="(item, index) in 4"
                            :key="'ProductInt-' + index"

                    >
                        <div class="pro">
                            <div class="pro-top">
                                <img src="@/assets/img/empty.png" alt="" >
                                <div class="pro-top-content">
                                    <div>
                                        <span class="name">
                                        许巍发
                                         </span>
                                        <span class="job">
                                        市场部经理
                                         </span>
                                    </div>

                                    <div style="margin-top: 6px">
                                      <span class="company">
                                          上海联展软件有限公司
                                      </span>
                                    </div>
                                    <div style="margin-top: 14px">
                                        <span class="phone">18777777777</span>
                                    </div>
                                    <div style="margin-top: 10px">
                                        <span class="job">联系人 ：司机</span>
                                    </div>
                                    <button @click="modal1 = true">测试</button>
                                </div>
<!--                                <img :src="item.banner[0]" v-if="item.banner && item.banner[0]" />-->
<!--                                <img src="@/assets/img/empty.png" v-else />-->
                            </div>

                            <div class="pro-tool">

                                <div class="pro-tool-item">
                                    <Poptip
                                            width="160"
                                            confirm
                                            placement="top-start"
                                            title="确认删除此产品吗 ?"
                                            @on-ok="delItem(item, index)"
                                            @on-cancel="handleClose(index)"
                                    >删除</Poptip>
                                </div>

                            </div>
                        </div>
                    </Col>
                </Row>
                <div
                        class="my-page"
                        v-if="totalCount > pageSize"
                        style="text-align:center;padding-top: 20px"
                >
                    <Page
                            show-total
                            show-elevator
                            :page-size="pageSize"
                            :current="pageIndex"
                            :total="totalCount"
                            @on-change="changePage"
                            @on-page-size-change="changePageSize"
                    />
                </div>
            </div>
        </template>
        <emptyList v-else @change="Add()"></emptyList>
        <iModal
                v-model="modal1"
                :closable="false"
                cancel-text=""
                ok-text=""
                @on-ok="ok"
                :footer-hide="true"
               >
            <p style="text-align: center;padding-top: 86px;padding-bottom: 40px">你还未添加联系人员，请添加后再进行操作</p>
            <p style="text-align:center;padding-bottom: 86px;color: red;"><span style="cursor: pointer" @click="modal2 = true;modal1=false">立即添加</span></p>
        </iModal>
        <iModal
                v-model="modal2"
                :closable="false"
                @on-ok="ok"
        >
            <Select v-model="select" style="width:200px">
                <Option  :value="ces">测试人</Option>
            </Select>
        </iModal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import emptyList from "@components/emptyList/emptyList";

    export default {
        name: "exhibition-product-item",
        props: {
            searchField: {
                type: String,
                default() {
                    return "1";
                }
            }
        },
        data() {
            return {
                select:'',
                ces:'测试',
                modal1:false,
                modal2:false,
                deleted: false,
                edit: false,
                list: null,
                editInfo: null,

                pageSize: 20,
                pageIndex: 1,
                totalCount: 0
                // timer: null
            };
        },
        computed: {
            ...mapGetters({
                company: "loginModule/getCompany"
            }),
            option() {
                return {
                    CompId: this.company.id,
                    PageSize: this.pageSize,
                    PageIndex: this.pageIndex,
                    Wheres: {
                        type: 0,
                        wheres: {
                            WhereGroupOperator: 0,
                            Predicates: [
                                {
                                    type: 1,
                                    wheres: {
                                        WhereOperator: 6,
                                        Label: "Name",
                                        Value: `%${this.searchField}%`
                                    }
                                }
                            ]
                        }
                    }
                };
            }
        },
        components: {
            emptyList
        },
        created() {
            this.init();
        },
        methods: {
            ...mapActions({
                getProduct: "productModule/getProduct",
                delProduct: "productModule/delProduct",
                setProductShow: "productModule/setProductShow",
                getProductApply: "productFeedbackModule/getProductApply"
            }),
            ok () {
                this.$Message.info('Clicked ok');
            },
            async init() {
                let proData = await this.getProduct(this.option);
                // let proData123 = await this.getProduct({
                //   CompId: this.company.id,
                //   PageSize: proData.totalCount
                // });
                if (proData) {
                    proData.items.map(c => {
                        if (c.banner) {
                            c.banner = JSON.parse(c.banner);
                        } else {
                            c.banner = [];
                        }
                        c.visible = false;
                    });
                    this.list = proData;
                    this.pageSize = proData.pageSize;
                    this.pageIndex = proData.pageIndex;
                    this.totalCount = proData.totalCount;
                    this.$emit("dataChange",proData);
                }
                // console.log("proData：",proData);
                this.$emit("numChange",this.totalCount);
            },
            // 修改产品显示、屏蔽
            async showOff(item) {
                let result = await this.setProductShow({ Id: item.id, IsShow: false });
                if (result.successed) {
                    this.$Message.success("修改成功");
                    this.init();
                } else {
                    this.$Message.error("修改失败，请重新尝试");
                }
            },
            async showOn(item) {
                let result = await this.setProductShow({ Id: item.id, IsShow: true });
                if (result.successed) {
                    this.$Message.success("修改成功");
                    this.init();
                } else {
                    this.$Message.error("修改失败，请重新尝试");
                }
            },
            async listDown(item) {
                let applyList = await this.getProductApply({ By: item.id });
                let applyList2 = await this.getProductApply({
                    By: item.id,
                    PageSize: applyList.totalCount
                });
                const exData = this.transformData(applyList2.items);
                require.ensure([], () => {
                    const {
                        export_json_to_excel
                    } = require("../../../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
                    const tHeader = [
                        "姓名",
                        "职务",
                        "公司",
                        "手机号码",
                        "国家",
                        "省份",
                        "城市",
                        "县",
                        "地址"
                    ]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
                    const filterVal = [
                        "name",
                        "jobTitle",
                        "company",
                        "mob",
                        "country",
                        "province",
                        "city",
                        "county",
                        "address"
                    ]; //与表格数据配合 可以是iview表格中的key的数组
                    const data = this.formatJson(filterVal, exData);
                    export_json_to_excel(tHeader, data, "产品试用名单"); //列表excel  这个是导出表单的名称
                });
            },
            transformData(data) {
                // 转换数据
                let arr = [];
                data.forEach(c => {
                    arr.push({
                        name: c.name,
                        jobTitle: c.jobTitle,
                        company: c.company,
                        mob: c.mob,
                        country: c.country,
                        province: c.province,
                        city: c.city,
                        county: c.county,
                        address: c.address
                    });
                });
                return arr;
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },
            del(item) {
                this.$Modal.confirm({
                    content: `确认删除 ${item.name} 此产品吗 `,
                    onOk: () => {
                        this.delItem(item);
                    },
                    onCancel: () => {
                        this.deleted = false;
                    }
                });
            },
            async delItem(item) {
                let result = await this.delProduct(item.id);
                if (result.successed) {
                    this.$Message.success("删除成功");
                    this.init();
                } else {
                    this.$Message.error("删除失败，请重新尝试");
                }
            },
            Add() {
                this.$router.push("/exhibition/index/product/addpro");
            },
            showEdit(item) {
                // this.$Message.loading({
                //   content: "加载中...",
                //   duration: 0
                // });
                // setTimeout(() => {
                this.$router.push(`/exhibition/index/product/editpro?id=${item.id}`);
                // }, 300);
            },
            changePage(e) {
                this.pageIndex = e;
                this.init();
                
            },
            changePageSize(e) {
                this.pageSize = e;
                this.init();
                
            },
            setProStatus(start, end) {
                let status = {
                    end: false,
                    ing: false,
                    start: false
                };
                if (!start || !end) return status;
                let startNum = new Date(start).getTime();
                let endNum = new Date(end).getTime();
                let now = new Date().getTime();
                if (endNum < now) status.end = true;
                if (endNum > now && startNum < now) status.ing = true;
                if (startNum > now) status.start = true;
                return status;
            },

            handleOpen(index) {
                this.list.items[index].visible = true;
            },
            handleClose(index) {
                this.list.items[index].visible = false;
            },
            toggleOpen(index) {
                let visible = this.list.items[index].visible;
                this.list.items[index].visible = !visible;
            }
        }
    };
</script>

<style scoped lang="scss">
    .my-item3 {
        min-width: 600px;
        padding: 30px 30px 50px 30px;

    &-box {
         background-color: #fff;
         margin-bottom: 30px;
     }

    .addPro {
        background-color: #fff;
        width: 100%;
        padding-bottom: 66.666667%;
        position: relative;
        cursor: pointer;
    div {
        width: 100%;
        height: 90px;
    }
    .icon{
        font-size: 60px;
        width: 100%;
        text-align: center;
        display: block;
        color:#999;
        position: absolute;
        bottom: 45%;
    }
    span{
        display: block;
        width: 100%;
        font-size: 18px;
        color:#999;
        text-align: center;
        position: absolute;
        bottom: 30%;
        text-align: center;
    }
    }
    .pro {
        margin-bottom: 20px;
        position: relative;
    &-top {
         width: 100%;
        height: 158px;
         /*padding-bottom: 66.666667%;*/
         position: relative;
         background-color: #fff;
        &-content{
            padding: 28px 20px 20px;
            .name{
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #333;
            }
            .job{
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #8c8c8c;
            }
            .company{
                font-size: 14px;
                color: #8c8c8c;
                margin-top: 10px;
            }
            .phone{
                color: #262626;
                font-size: 16px;
                margin-top: 24px;
            }
        }
    img {
        position: absolute;
        top: 23px;
        right:20px;
        width:70px;
        height:70px;
        border-radius: 50%
    }
    }

    &-title {
         background: #fff;
     // height: 33px;
         padding: 10px 10px 8px 12px;
    .info,
    .time {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #1a1a1a;
        text-align: center;
    &.end {
         color: #f00;
     }
    &.ing {
         color: green;
     }
    &.start {
         color: #fe791e;
     }
    }
    .time {
        color: #fe791e;
    }
    }

    &-tool {
         display: flex;
         align-items: center;
         justify-content: space-around;
         background-color: #f8f9fb;

    &-item {
         flex: 1;
         line-height: 48px;
         font-size: 14px;
         color: #808080;
         cursor: pointer;
         text-align: center;

    &.z-del {
         color: #f00;
     }

    &.z-primary {
         color: #1890ff;
     }
    }

    &-line {
         color: #e8e8e8;
         font-size: 20px;
     }
    }
    }

    .my-page {
        padding-bottom: 50px;
    }
    .product-show {
        position: absolute;
        z-index: 1;
        right: 0;
        width: 0;
        height: 0;
        border-width: 20px;
        border-style: solid;
        border-color: #ccc #ccc transparent transparent;
    i {
        position: absolute;
        top: -25px;
        right: -20px;
        color: #fff;
        font-size: 25px;
    }
    }
    }
</style>
